module.exports = __webpack_public_path__ + "static/media/cu04_ch02.f65eefe2.png";